import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import authHeader from "../services/auth-header";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useTranslation } from "react-i18next";

import ReactDOM from "react-dom";

const api = require("../api/names.js");

function LedTables() {

    const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        var url = api.baseUrl + '/ledTables/';
        console.log(url);

        fetch(url, {
            method: 'get',
            headers: authHeader()
        })
            .then(res => res.json())
            .then(
                (res) => {
                    setItems(res);
                    setIsLoaded(true);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, []);

    function seconds2time(seconds) {
        var hours = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = seconds - (hours * 3600) - (minutes * 60);
        var time = "";

        if (hours !== 0) {
            time = hours + "h ";
        }
        if (minutes !== 0 || time !== "") {
            minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
            time += minutes + "min ";
        }
        if (time === "") {
            time = seconds + "s";
        }
        else {
            time += (seconds < 10) ? "0" + seconds : String(seconds) + "s";
        }
        return time;
    }

    function timeDifference(t){
        var date = Math.floor(new Date(Date.now()).getTime() / 1000);
        var date2 = Math.floor(new Date(t).getTime() / 1000);
        var time = seconds2time(date-date2);
        return time;
    }

    if (error) {
        return <div>{t('detectord.error')}{error.message}</div>;
    } else if (!isLoaded) {
        return <div>{t('detectord.loading')}</div>;
    } else {
        console.log(items);
        
        return (
            <div>
                <br />
                <Button href='/parkings' variant="outlined" startIcon={<ArrowBackIcon />}>
                    {t('parkingd.comeback')}
                </Button>
                <Button href='/ledTableNew' variant="outlined">
                    Led New
                </Button>
                <br />
                <br />
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell >nr slupa</TableCell>
                                <TableCell >ulica</TableCell>
                                <TableCell >opis</TableCell>
                                <TableCell >ip</TableCell>
                                <TableCell >status</TableCell>
                                <TableCell >opis statusu</TableCell>
                                <TableCell >ostatnia zmiana</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item) => (
                                <TableRow
                                    key={item.address}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell >{item.poleNumber}</TableCell>
                                    <TableCell >{item.street}</TableCell>
                                    <TableCell >{item.desription}</TableCell>
                                    <TableCell >{item.ip}</TableCell>
                                    <TableCell >{item.status}</TableCell>
                                    <TableCell >{item.statusDescription}</TableCell>
                                    <TableCell >{timeDifference(item.updatedAt)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}

export default LedTables;

ReactDOM.render(<LedTables />, document.getElementById("root"));
